<template>
  <b-form-group
    label="Zones"
    label-for="zones"
  >
    <v-select
      id="zones"
      v-model="selectedZones"
      label="name"
      :options="zones"
      :loading="loadingZones"
      :disabled="disabled"
      :class="{ 'disabled-zones-select': disabled }"
      multiple
      :reduce="zone => `${zone.country}::${zone.city}`"
      @input="onZonesSelected"
    />
  </b-form-group>
</template>

<style>
/* Fix disabled v-select text visibility */
.disabled-zones-select.vs--disabled .vs__selected {
  color: #495057 !important;
  opacity: 1 !important;
}

.disabled-zones-select.vs--disabled .vs__dropdown-toggle {
  background-color: #f8f9fa !important;
  border-color: #dee2e6 !important;
  opacity: 1 !important;
}

.disabled-zones-select.vs--disabled .vs__selected-options {
  color: #495057 !important;
  opacity: 1 !important;
}

.disabled-zones-select.vs--disabled .vs__search {
  color: #495057 !important;
  opacity: 1 !important;
}

.disabled-zones-select.vs--disabled {
  opacity: 1 !important;
}
</style>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import { computed, watch, ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import useZoneList from '@/views/zones/useZoneList'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import zonesStore from '@/views/zones/zoneStoreModule'

export default {
  components: {
    BFormGroup,
    vSelect,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    useRegisterStoreModule('zones', zonesStore)

    const { tableData: fetchedZones, loadingZones, ...rest } = useZoneList()
    const selectedZones = ref(props.value)

    const zones = computed(() => {
      let temp = []
      temp = fetchedZones.value?.filter(el => el.area === 'None')
      return temp
    })

    const onZonesSelected = event => {
      selectedZones.value = event || []
      ctx.emit('input', selectedZones.value)
    }

    watch(() => props.value, newValue => {
      selectedZones.value = newValue
    }, { immediate: true })

    // Watch for zones loading completion and update selected zones
    watch(fetchedZones, newZones => {
      if (newZones && newZones.length > 0 && props.value && props.value.length > 0) {
        selectedZones.value = [...props.value]
      }
    })

    watch(loadingZones, () => {
      ctx.emit('zones-loading-state', loadingZones.value)
    }, { immediate: true })

    return {
      loadingZones,
      selectedZones,
      ...rest,
      zones,
      onZonesSelected,
    }
  },
}
</script>
